import { createEvent } from "ics";
import { downloadFile } from "./download-file";
import getLongTitle from "./get-long-title";
import getAnyDescription from "./get-any-description";
import moment from "moment";

export default function createICal(event) {
  const start = moment(event.moment.from);
  const end = moment(event.moment.to);

  start.subtract(start.utcOffset(), "m");
  end.subtract(end.utcOffset(), "m");

  const ev = {
    uid: event._id + "-" + event.moment._id,
    start: start.format("YYYY-M-D-H-m").split("-"),
    end: end.format("YYYY-M-D-H-m").split("-"),
    title: getLongTitle(event),
    description: getAnyDescription(event),
    url: window.location.href,
    productId: "eo/events"
  };

  // add geo, if possible
  if (event.location) {
    ev.location = event.location.title;
    if (
      event.location.geo &&
      event.location.geo.coordinates &&
      event.location.geo.coordinates.length === 2
    ) {
      ev.geo = {
        lat: event.location.geo.coordinates[0],
        lon: event.location.geo.coordinates[1]
      };
    }
  }

  // create ics data set
  createEvent(ev, (error, value) => {
    if (error) {
      return error;
    }

    downloadFile(
      value,
      event.url_slug + "-" + event.moment._id + ".ics",
      "text/calendar"
    );
  });
}
